import { sanitizeFetchType } from 'react-admin'
import { ResourceName } from '../../ResourceName'
import {
  ToggleButtonAction,
  ToggleButtonState,
  ToggleType,
} from './barrier-set-boolean-status-button'
import { BarrierDto } from '../../dto/device/barrier/barrier.dto'

type Mutation = {
  type: string
  resource: string
  // eslint-disable-next-line @typescript-eslint/ban-types
  payload?: object
}

const turnOffMutation = (
  { id }: BarrierDto,
  auditNote?: string,
  recurringJobName?: string,
  cronExpression?: string,
): Mutation => ({
  type: sanitizeFetchType('setPPOZState'),
  resource: ResourceName.BARRIERS,
  payload: {
    barrierId: id,
    ppozState: false,
    auditComment: auditNote,
    recurringJobName,
    cronExpression,
  },
})

const turnOnMutation = (
  { id }: BarrierDto,
  auditNote?: string,
  recurringJobName?: string,
  cronExpression?: string,
): Mutation => ({
  type: sanitizeFetchType('setPPOZState'),
  resource: ResourceName.BARRIERS,
  payload: {
    barrierId: id,
    ppozState: true,
    auditComment: auditNote,
    recurringJobName,
    cronExpression,
  },
})

type State = {
  mutateQuery?: (
    barrier: BarrierDto,
    auditNote?: string,
    recurringJobName?: string,
    cronExpression?: string,
  ) => Mutation
} & ToggleButtonState

export const barrierSetPPOZButtonInitialState = {
  type: ToggleType.OFF,
  text: 'resources.barriers.actions.setPPOZState.turnOn',
}

export const barrierSetPPOZButtonReducer = (
  state: State,
  { type }: ToggleButtonAction,
): State => {
  switch (type) {
    case ToggleType.OFF: {
      return {
        type,
        text: 'resources.barriers.actions.setPPOZState.turnOn',
        mutateQuery: turnOnMutation,
      }
    }
    case ToggleType.ON: {
      return {
        type,
        text: 'resources.barriers.actions.setPPOZState.turnOff',
        mutateQuery: turnOffMutation,
      }
    }
    default:
      throw new Error()
  }
}
